import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-93ac4802")

_pushScopeId("data-v-93ac4802")
const _hoisted_1 = {
  class: "ui__attach_main",
  id: "PhotoInfo"
}
const _hoisted_2 = { class: "ui__attach_body" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "ui__attach_title" }, "附加照片", -1)
const _hoisted_4 = { class: "ui__attach_cnt" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createVNode("h6", null, "查看全部", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.photoList.slice(0,3), (item, index) => {
          return (_openBlock(), _createBlock("div", {
            class: "ui__attach_cnt_item",
            key: item.photoIdStr
          }, [
            (index < 2)
              ? (_openBlock(), _createBlock("div", _hoisted_5, [
                  _createVNode("img", {
                    src: item.smallPhotoUrl ? _ctx.urlConversion(item.smallPhotoUrl) : _ctx.urlConversion(item.photoPath)
                  }, null, 8, ["src"]),
                  _createVNode("p", null, _toDisplayString(item.photoName), 1)
                ]))
              : _createCommentVNode("", true),
            (index === 2)
              ? (_openBlock(), _createBlock("div", _hoisted_6, [
                  _createVNode("img", {
                    src: item.smallPhotoUrl ? _ctx.urlConversion(item.smallPhotoUrl) : _ctx.urlConversion(item.photoPath)
                  }, null, 8, ["src"]),
                  _createVNode("div", {
                    class: "ui__attach_cnt_item_cover",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goPhoto && _ctx.goPhoto(...args)))
                  }, [
                    _createVNode("h6", null, "共" + _toDisplayString(_ctx.state.photoLength) + "张", 1),
                    _hoisted_7
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ])
  ]))
})